// import React from "react";
// import Main from "../pages/Main";
// import AppBreadcrumbs from "./ui/AppBreadcrumbs";
// import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
// import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";

// import BrandLogo from "../utils/logoImg";
// const IdCard = () => {
//     const navigate = useNavigate();
//      const { userInfo } = useSelector((state) => state?.auth);
//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4 font-[Poppins]">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "Agent Profile" },
//             { label: "ID Card" },
//           ]}
//         />
// <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-2 mb-4 mt-4 flex items-center justify-between">
//   <div className="flex items-center gap-2">
//     <img
//       src={`${userInfo?.logo}`}
//       alt="profile"
//       className="h-10 w-10 object-cover rounded-md"
//     />
//     {}
//     <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap">
//       {}
//       <p className="text-[13px] md:text-[15px] font-semibold">
//         {userInfo?.name || "Guest"} 
//       </p>
//       {}
//       <p className="hidden md:block text-[18px] font-semibold">|</p>
//       {}
//       <p className="text-[11px] md:text-[15px] font-semibold md:mt-0 mt-[2px]">
//         ID: {userInfo?.userName || "N/A"}
//       </p>
//     </div>
//   </div>
//   <div className="flex items-center gap-3">
//     {}
//     <button
//       onClick={() => navigate(-1)}
//       className="bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold 
//       hover:opacity-90 transition whitespace-nowrap flex items-center gap-2"
//     >
//       <PersonRoundedIcon fontSize="small" />
//       <span className="hidden md:inline">Back To Profile</span>
//     </button>
//     {}
//  <button
//   onClick={() => window.print()}
//   className="
//     bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold 
//     hover:opacity-90 transition whitespace-nowrap flex items-center gap-2
//   "
// >
//   <PrintRoundedIcon fontSize="small" />
//   <span className="hidden md:inline">Print</span>
// </button>

//   </div>
// </div>
// <div className="print-area shadow-sm border border-gray-300 rounded-lg p-6 mt-4 flex justify-center">
//   <div className="w-[380px] border border-gray-400 px-6 py-6">
//     <div className="text-center flex items-center justify-center flex-col">
//       {/* <h1 className="text-[32px] font-bold">
//         <span className="text-[#01acf1]">Just</span>
//         <span className="text-[#e63946]">Pay</span>
//       </h1> */}
//          <BrandLogo variant="blue" size="lg" />
//       <p className="text-[12px] font-semibold  mt-1">
//         AAP EK KADAM, HUM HAR KADAM AAPKE SATH
//       </p>
//       <p className="text-[11px]  font-semibold">
//         U72900DL2021PTC377056
//       </p>
//     </div>
//     <hr className="my-4 border-gray-300" />
//     <div className="flex justify-center">
//       <img
//         src={`${userInfo?.logo}`}
//         alt="profile"
//         className="w-40 h-48 object-cover rounded-md border border-gray-400"
//       />
//     </div>
//     <div className="text-center mt-4 leading-6">
//       <p className="font-bold text-lg text-[#d90429]">
//         {userInfo?.name}
//       </p>
//       <p className="text-sm font-semibold ">
//         BRANCH : MAIN BRANCH
//       </p>
//       <p className="text-sm font-semibold  uppercase">
//         DESIGNATION : {userInfo?.role}
//       </p>
//       <p className="text-sm font-semibold ">
//         CSP CODE : {userInfo?.userName || "SDA107793"}
//       </p>
//       <p className="text-sm font-semibold ">
//         MOBILE NO. : {userInfo?.phone || "8882414207"}
//       </p>
//     </div>
//     <hr className="my-4 border-gray-300" />
//     <p className="text-center text-[12px] font-semibold ">
//      {userInfo?.kycIdId?.address}
//     </p>
//   </div>
// </div>
//       </div>
//     </Main>
//   );
// };
// export default IdCard;

import React from "react";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import BrandLogo from "../utils/logoImg";
import { useBranding } from "../context/BrandingContext";

const IdCard = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state?.auth);

  const { settings, mediaUrl, companyName } = useBranding();

  const companyLogo = settings?.certificateLogoUrl
    ? mediaUrl(settings.certificateLogoUrl)
    : null;

  const companyTagline = settings?.tagline || "";
  const companyCIN = settings?.cin || settings?.CIN || "";
  const companyPhone = settings?.supportPhone || settings?.phone || "";
  const companyEmail = settings?.supportEmail || settings?.email || "";
  const companyWebsite = settings?.websiteUrl || settings?.website || "";
  const companyAddress =
    settings?.address || userInfo?.kycId?.address || "-";

  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        {/* BREADCRUMBS */}
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Agent Profile" },
            { label: "ID Card" },
          ]}
        />

        {/* PROFILE HEADER */}
        <div className="ds-card p-2 mb-4 mt-4 flex flex-wrap md:flex-nowrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src={userInfo?.logo}
              alt="profile"
              className="h-10 w-10 rounded-md object-cover"
            />

            <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap">
              <p className="text-[13px] md:text-[15px] font-semibold text-[var(--text-dark)]">
                {userInfo?.name || "Guest"}
              </p>

              <p className="hidden md:block text-[18px] font-semibold text-[var(--text-muted)]">
                |
              </p>

              <p className="text-[11px] md:text-[15px] font-semibold text-[var(--text-dark)]">
                ID: {userInfo?.userName || "N/A"}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold hover:opacity-90 transition whitespace-nowrap flex items-center gap-2"
            >
              <PersonRoundedIcon fontSize="small" />
              <span className="hidden md:inline">Back To Profile</span>
            </button>

            <button
              type="button"
              onClick={() => window.print()}
              className="bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold hover:opacity-90 transition whitespace-nowrap flex items-center gap-2"
            >
              <PrintRoundedIcon fontSize="small" />
              <span className="hidden md:inline">Print</span>
            </button>
          </div>
        </div>

        {/* ID CARD */}
        <div className="ds-card p-4 sm:p-6 mt-4 flex justify-center">
          <div className="print-area w-full max-w-[400px]">
            <div className="rounded-lg border border-[var(--border-color)] bg-[var(--bg-app)] p-5 sm:p-6 shadow-sm">
              {/* COMPANY DETAILS */}
              <div className="text-center flex items-center justify-center flex-col">
                {companyLogo ? (
                  <img
                    src={companyLogo}
                    alt={companyName || "Company Logo"}
                    className="h-12 sm:h-14 max-w-[220px] object-contain"
                  />
                ) : (
                  <BrandLogo variant="blue" size="lg" />
                )}

                {/* <p className="text-sm sm:text-base font-bold text-[var(--text-dark)] mt-2 uppercase">
                  {companyName || "Company"}
                </p>

                {companyTagline ? (
                  <p className="text-[10px] sm:text-[11px] font-medium text-[var(--text-muted)] mt-1">
                    {companyTagline}
                  </p>
                ) : null} */}

                {companyCIN ? (
                  <p className="text-[10px] sm:text-[11px] font-semibold text-[var(--text-dark)] mt-1">
                    CIN: {companyCIN}
                  </p>
                ) : null}
              </div>

              <div className="border-t border-[var(--border-color)] my-4" />

              {/* USER PHOTO */}
              <div className="flex justify-center">
                <div className="rounded-md border border-[var(--border-color)] p-1">
                  <img
                    src={userInfo?.logo}
                    alt={userInfo?.name || "Profile"}
                    className="w-40 h-40 sm:w-40 sm:h-40 object-fit rounded"
                  />
                </div>
              </div>

              {/* USER DETAILS */}
              <div className="text-center mt-4 space-y-1">
                <p className="text-lg font-bold text-[var(--text-dark)]">
                  {userInfo?.name || "-"}
                </p>

                <p className="text-xs sm:text-sm font-semibold text-[var(--text-dark)] uppercase">
                  BRANCH : {userInfo?.branch || "MAIN BRANCH"}
                </p>

                <p className="text-xs sm:text-sm font-semibold text-[var(--text-dark)] uppercase">
                  DESIGNATION : {userInfo?.role || "-"}
                </p>

                <p className="text-xs sm:text-sm font-semibold text-[var(--text-dark)]">
                  CSP CODE : {userInfo?.userName || "-"}
                </p>

                <p className="text-xs sm:text-sm font-semibold text-[var(--text-dark)]">
                  MOBILE NO. : {userInfo?.phone || "-"}
                </p>
              </div>

              <div className="border-t border-[var(--border-color)] my-4" />

              {/* COMPANY CONTACT DETAILS */}
              <div className="text-center space-y-1.5">
                {companyPhone ? (
                  <p className="text-[10px] sm:text-[11px] font-medium text-[var(--text-dark)]">
                    Support: {companyPhone}
                  </p>
                ) : null}

                {companyEmail ? (
                  <p className="text-[10px] sm:text-[11px] font-medium text-[var(--text-dark)] break-all">
                    {companyEmail}
                  </p>
                ) : null}

                {companyWebsite ? (
                  <p className="text-[10px] sm:text-[11px] font-medium text-[var(--text-dark)] break-all">
                    {companyWebsite}
                  </p>
                ) : null}

                <p className="text-[10px] sm:text-[11px] font-semibold text-[var(--text-dark)] leading-5 pt-1">
                  {companyAddress}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default IdCard;